"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getApplicableDateSegments = void 0;
/*
 * Determines which part of a datestamp we are collecting.
 */
const getApplicableDateSegments = (dateFormat) => {
    const parts = dateFormat.match(/^(YYYY)?-?(MM)?-?(DD)?$/i);
    if (!parts) {
        throw new Error("invalid date format");
    }
    return {
        day: !!parts[3],
        month: !!parts[2],
        year: !!parts[1]
    };
};
exports.getApplicableDateSegments = getApplicableDateSegments;
//# sourceMappingURL=getApplicableDateSegments.js.map